// Add one entry per article here. `src` is the link to embed (e.g. a
// published Google Doc/Slides/Sheets link, or any other embeddable URL).
const ARTICLES = [
  {
    slug: 'from-wires-to-a-working-game',
    title: 'From Wires to a Working Game',
    date: '25-07-2026',
    intro: 'How Rohan Built a Sort Game with Arduino.',
    src: 'https://docs.google.com/document/d/11b4BGHkS6cnvAY0l2b-vaLk5Kbce2nqZ/preview',
  },
  {
    slug: 'remember-the-danger-zones',
    title: 'Remember the Danger Zones',
    date: '20-06-2026',
    intro: 'How Devi Built a Memory-Maze Game with Arduino.',
    src: 'https://docs.google.com/document/d/1sF3yHWSnzg_afNYpariKE5BAqgG8c32h/preview',
  },
  {
    slug: 'from-blinking-lights-to-a-real-game',
    title: 'From Blinking Lights to a Real Game',
    date: '05-05-2026',
    intro: 'How Ishaan Built a Number-Sorting Game with Arduino',
    src: 'https://docs.google.com/document/d/15kQwHKmMeKtL19LvH3p6ry3VM9d9zQG4/preview',
  },
  {
    slug: 'alphafold-3-to-predict-protein-structure-and-interactions',
    title: 'AlphaFold 3 to predict protein structure and interactions',
    date: '05-05-2026',
    intro: 'How Mohan used AlphaFold 3 to predict protein structure and interactions',
    src: 'https://docs.google.com/document/d/1VRxIGC9JWDXE7I3b30FJFOZ1amuj5MddSFUwhqjIf9E/preview',
  },
  {
    slug: 'microscopy-activities',
    title: 'Microscopy Activities',
    date: '27-09-2026',
    intro: 'How high school students could get curiosity while they view microscopic things using a microscope ?',
    src: 'https://docs.google.com/document/d/1WJukAWPHqvlL3Zzb5yJ6oINWbxjqBXNzsiiLnd-nsOo/preview',
  },
];

export default ARTICLES;
